import React, {useEffect} from "react";
import {MainMenu as Menu} from "Components/Menu/MainMenu";
import {getPageType} from "Helpers/PageHelper";
import {HamburgerButton} from "Components/BurgerButton/HamburgerButton";
import {Logo} from "Components/Menu/MenuComponents";
import {PageTransition} from "Animations";
import {LOGINPAGE} from "Consts/pageTypes";
import {Page as PageContainer, PageWrapper, SplitPageWrapper} from "BaseComponents/Wrappers";
import useBreakpoint from "Hooks/useBreakpoint";
import {STICKYBLOCK} from "Consts/blockTypes";

const BasePage = ({model, searchQuery, element}) => {
    const {MainMenu, Breadcrumb, CookieData, Alias, FooterData, CurrentUser, ...rest} =
        model;

    const getAllElems = () => {
        const onPageLoad = () => {
            const hasSticky = model?.ElementArea?.find(c => c.Alias === STICKYBLOCK);
            const hasStickyTop = model?.TopElementArea?.find(c => c.Alias === STICKYBLOCK);
            if (hasSticky !== undefined || hasStickyTop !== undefined) {
                document.body.classList.add('has__sticky');
            }
            addStyleToSticky();
        };

        const addStyleToSticky = (isMobile) => {
            const stickyBlocks = document.querySelectorAll(".stickyBlock");
            if (stickyBlocks?.length > 0) {
                stickyBlocks.forEach((item, index) => {
                    item.style.width = isMobile ? 'unset' : item.parentElement.clientWidth + 'px';
                });
            }
        }
        const onPageResize = (event) => {
            if (Math.min(window.screen.width, window.screen.height) < 1024) {
                addStyleToSticky(true);
            } else {
                addStyleToSticky(false);
            }
        }

        if (document.readyState === "complete") {
            onPageLoad();
        } else {
            window.addEventListener("load", onPageLoad, false);
            return () => window.removeEventListener("load", onPageLoad);
        }
        window.addEventListener("resize", onPageResize);
    };

    useEffect(() => {
        getAllElems();
    }, []);

    useEffect(() => {
        const profileUrl = "/profilsida";
        if (!!CurrentUser) {
            const {IsConfirmed, FirstName} = CurrentUser;
            if (
                FirstName != undefined &&
                !IsConfirmed &&
                window.location.pathname !== profileUrl
            ) {
                window.location.href = profileUrl;
            }
        }
    });

    return Alias !== LOGINPAGE ? (
        <PageWrapper className={Alias}>
            <HamburgerButton/>
            <PageTransition element={element} alias={Alias}>
                <SplitPageWrapper>
                    {useBreakpoint("ipad", 'down') && MainMenu != undefined && (
                        <Logo
                            align="flex-start"
                            margin="15px 10px"
                            width="177px"
                            Src={MainMenu.MenuLogo}
                        />
                    )}

                    {MainMenu && <Menu currentUser={CurrentUser} {...MainMenu}></Menu>}
                    <PageContainer Breadcrumb={Breadcrumb} Alias={Alias}>
                        {getPageType(rest, Alias, searchQuery, CurrentUser)}
                    </PageContainer>
                </SplitPageWrapper>
            </PageTransition>
        </PageWrapper>
    ) : (
        <PageWrapper className={Alias}>{getPageType(rest, Alias, searchQuery)}</PageWrapper>
    );
};

export default BasePage;
